'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    (0, _jquery2.default)("[data-editable-cell-icon]").each(function () {
        var $this = (0, _jquery2.default)(this);
        var complaintProductId = $this.attr("data-editable-cell-icon");

        $this.click(function (e) {
            e.preventDefault();
            var $input = $this.siblings("[data-editable-cell]");
            $input.removeAttr("readonly");
            $input.removeClass("editable-cell-text");
            $input.addClass("editable-cell-input");
            $input.focus();
            var tmpStr = $input.val();
            $input.val('');
            $input.val(tmpStr);
        });
    });

    (0, _jquery2.default)("[data-editable-cell]").each(function () {
        var $this = (0, _jquery2.default)(this);

        $this.on("focusout keydown", function (e) {
            if (e.type == "focusout" || e.keyCode == 13) {
                var value = $this.val();
                var formerValue = $this.attr("data-editable-cell");

                if (value != formerValue) {
                    $this.attr("data-editable-cell", value);
                    var complaintId = $this.attr("data-editable-cell-complaintId");
                    var newValue = $this.val();
                    $this.attr("readonly", "readonly");
                    $this.removeClass("editable-cell-input");
                    $this.addClass("editable-cell-text");
                    var table = $this.closest(".dataTable").DataTable();

                    var url = correctUrl(table.ajax.url()) + '(' + complaintId + ')';
                    _jquery2.default.ajax({
                        url: url,
                        method: 'PATCH',
                        data: JSON.stringify({ "complaintAmount": newValue }),
                        dataType: 'json',
                        contentType: 'application/json; charset=UTF-8'
                    }).done(function (result) {
                        _notify2.default.success(resx.Common.UpdateSuccess);
                        table.ajax.reload(null, false);
                    }).fail(function (result) {
                        _notify2.default.error(resx.App.ComplaintUpdateError);
                        table.ajax.reload(null, false);
                    });
                }
            }
        });
    });

    var correctUrl = function correctUrl(url) {
        return url.split('?')[0];
    };
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("App", "Common");

var complaintService = _abp2.default.services.api.complaint;


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/edit-cell.js
// module id = 429
// module chunks = 0